import { ThinkingOrb } from "thinking-orbs"

// thinking-orbs only ships tuned presets for these two sizes and six states;
// any other value throws inside its mount effect, so clamp inputs here.
const LOADING_ORB_SIZES = [ 20, 64 ]
const LOADING_ORB_STATES = new Set([ "working", "searching", "solving", "listening", "composing", "shaping" ])

export function loadingOrbSize(size) {
  const value = Number(size)
  if (!Number.isFinite(value)) return 20
  return LOADING_ORB_SIZES.reduce((nearest, candidate) => (
    Math.abs(candidate - value) < Math.abs(nearest - value) ? candidate : nearest
  ))
}

export function loadingOrbState(state) {
  return LOADING_ORB_STATES.has(state) ? state : "working"
}

export function LoadingOrb({ className = "", label = null, size = 20, state = "working", theme = "dark" }) {
  const classes = [ "loading-orb", className ].filter(Boolean).join(" ")

  return (
    <ThinkingOrb
      aria-hidden={label ? undefined : "true"}
      aria-label={label || undefined}
      className={classes}
      size={loadingOrbSize(size)}
      state={loadingOrbState(state)}
      theme={theme}
    />
  )
}
